import { render, staticRenderFns } from "./Loadding.vue?vue&type=template&id=f625a064&"
import script from "./Loadding.vue?vue&type=script&lang=js&"
export * from "./Loadding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports